import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import ConnectButton from './ConnectButton';

function Dashboard() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('zaptime_user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('zaptime_user');
    localStorage.removeItem('zaptime_token');
    navigate('/login');
  };

  if (!user) {
    return <div style={styles.loading}>Carregando...</div>;
  }

  const isAdmin = user.username === 'admin';

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1 style={styles.title}>🚀 ZappExpress - Multi-Usuário</h1>
        <div style={styles.userInfo}>
          <span style={styles.userName}>
            👤 {user.username}
            {isAdmin && <span style={styles.adminBadge}>ADMIN</span>}
          </span>
          <button onClick={handleLogout} style={styles.logoutBtn}>
            Sair
          </button>
        </div>
      </header>

      <nav style={styles.nav}>
        <Link to="/" style={{...styles.navLink, ...styles.navLinkActive}}>🏠 Dashboard</Link>
        <Link to="/flows" style={styles.navLink}>📋 Meus Fluxos</Link>
        {isAdmin && (
          <Link to="/users" style={styles.navLink}>👥 Usuários</Link>
        )}
      </nav>

      <main style={styles.main}>
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>📱 Conectar WhatsApp</h2>
          <ConnectButton />
        </div>

        <div style={{...styles.card, ...styles.infoCard}}>
          <h3 style={styles.infoTitle}>ℹ️ Informações</h3>
          <ul style={styles.list}>
            <li>✅ Sistema multi-usuário ativo</li>
            <li>✅ Sessões isoladas por usuário</li>
            <li>✅ Editor visual de fluxos disponível</li>
            <li>✅ Suporte a múltiplos tipos de mensagens</li>
            {isAdmin && <li>✅ Gerenciamento de usuários (Admin)</li>}
          </ul>
        </div>

        <div style={{...styles.card, ...styles.infoCard}}>
          <h3 style={styles.infoTitle}>🚀 Como Usar</h3>
          <ol style={styles.list}>
            <li>1. Conecte seu WhatsApp usando o QR Code acima</li>
            <li>2. Acesse "📋 Meus Fluxos" no menu</li>
            <li>3. Crie e edite seus fluxos</li>
            <li>4. <strong>Ative os fluxos</strong> clicando em "▶️ Ativar"</li>
            <li>5. Teste enviando a mensagem gatilho no WhatsApp</li>
            {isAdmin && <li>6. Use "👥 Usuários" para gerenciar contas</li>}
          </ol>
        </div>
      </main>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#1a1a1a'
  },
  header: {
    backgroundColor: '#2c3e50',
    color: 'white',
    padding: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
  },
  title: {
    margin: 0,
    fontSize: '24px'
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px'
  },
  userName: {
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  adminBadge: {
    backgroundColor: '#3498db',
    padding: '4px 12px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: 'bold'
  },
  logoutBtn: {
    padding: '8px 16px',
    backgroundColor: '#e74c3c',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 'bold'
  },
  nav: {
    backgroundColor: '#34495e',
    padding: '15px 20px',
    display: 'flex',
    gap: '20px'
  },
  navLink: {
    color: 'white',
    textDecoration: 'none',
    fontSize: '16px',
    padding: '8px 16px',
    borderRadius: '4px',
    transition: 'background-color 0.3s'
  },
  navLinkActive: {
    backgroundColor: 'rgba(255,255,255,0.1)'
  },
  main: {
    padding: '30px',
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'grid',
    gap: '20px',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))'
  },
  card: {
    backgroundColor: '#2a2a2a',
    border: '1px solid #444',
    padding: '25px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
  },
  cardTitle: {
    marginTop: 0,
    marginBottom: '20px',
    color: '#fff',
    fontSize: '20px'
  },
  infoCard: {
    backgroundColor: '#2a2a2a'
  },
  infoTitle: {
    marginTop: 0,
    marginBottom: '15px',
    color: '#fff',
    fontSize: '18px'
  },
  list: {
    lineHeight: '2',
    color: '#bbb'
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontSize: '20px',
    color: '#ccc',
    backgroundColor: '#1a1a1a'
  }
};

export default Dashboard;